import Vue from 'vue';
import Vuex from 'vuex'
Vue.use(Vuex);

import * as getters from './getters';
import * as actions from './actions';

const store = new Vuex.Store({

    /* State */
    state: {

        /* config overwritten on load */
        config : {
            root : "",
            debug : false,
            domain : "",
            defaultLanguage : "" ,
            apiurl  : ""
        },

        domElements : {
            mainApp : "#mainApp",
            sidebar : "#sidebar",
            mainContent : "#mainContent"
        },

        /* important state variables */
        count: 0,
        ready: false,
        loaded : false,
        language : 'de',

        /* sidebar */
        sidebar : { 
            status : 0, // hidden = 0, collapsed = 1, expanded = 2
            expanded : false, 
            hidden: true,
            widthExpanded: 200,
            widthCollapsed: 80,
            widthHidden:40 
        },

        /* layout */
        layout : {
            height : 100,
            width : 100,
            margin : 40,
            gutter : 20,
            sidebarWidth : 40,
            viewportWidth : 0,
            viewportHeight : 0,
            galleryHeight : 0,
            galleryWidth : 0,

            fullscreen : false,

            type : false,
            ratio : false,
            orientation : false,
            breakpointMobile : 800,
            breakpointTablet : 1024,

            mobileNavigation : false,

            mobileSandwichColumn : 60,
            mobileGutter : 20,
            offsetTop : 0,
            offsetLeft : 0
        },

        mouse : {
          last : { x : 0, y : 0 },
          delataX : 0,
          deltaY : 0
        },

        downloadTermsAccepted : false,
        downloadTermsVisible : false,
        downloadRequestedImage : false,
        currentProject : null,
        projectsScrollLastY : 0,
        projectsScrollPosition: 0,
        projectsCurrentIndex : 0,
        projectsCurrentId : '',
        projectsCurrentType : '',
        projectsCurrentInfo :false ,
        projectMove : 0,
        projectMoveRight : 0,
        projectMoveLeft : 0,
        pageMove : 0,
        projectRerender : false,
        projectsVisible : true,


        /* data */
        projects : [],
        categories : [],
        clients : [],
        filteredProjects: [],
        categoryFilter: false,
        clientFilter: '',
        selectedProject : false,
        selectedCategory : false,
        pages : [],
        navItems : {
            about : { de : 'Profil', en : 'About' } ,
            contact : { de : 'Kontakt', en : 'Contact' },
            clients : { de : 'Kunden', en : 'Clients' },
            makingOf : { de : "Making Of", en : 'Making Of' },
            agb      : { de : "AGB", en : 'TAC' }

        },

        textVariables : {
            'example' : { de : 'Beispiel', en : 'Example' },
            'allProjects' : { de : 'Alle Projekte', en : 'All projects' }
        }


    },

    /* Getters */
    getters ,


    /* Mutations */
    mutations: {


        // toggle Sidebar
        toggleSidebar(state) {
           state.layout.sidebar.expanded = !state.layout.sidebar.expanded; 
           console.log(state.layout.sidebar.expanded);
        },

        setSidebar(state, n) {
           state.sidebar.status = n; 
            if(n < 1) { state.layout.sidebarWidth = state.sidebar.widthHidden }
            if(n == 1) { state.layout.sidebarWidth = state.sidebar.widthCollapsed }
            if(n == 2) { state.layout.sidebarWidth = state.sidebar.widthExpanded }


            if(state.layout.type == 'large' ) {

                state.layout.viewportWidth = state.layout.width - state.layout.sidebarWidth - state.layout.margin ;
            }
        },

        setConfig(state, config) {
            state.config = config;

        },

        setCategories(state, categories) {
            state.categories = categories;
        },

        // load and prepare project and images for rendering
        setProjects(state, projects) {

            // loop over projects
            for(var i = 0; i < projects.length; i++) {
                
                projects[i].view = {
                    totalWidth : 100,
                    overlay : false,
                    title : false,
                    info : false
                }

                for(var p = 0; p < projects[i].images.length; p++)
                {
                    projects[i].images[p].view = {
                          index : p,
                          totalImages : projects[i].images.length,
                          scrollPosition : 20 * p,
                          width : 20,
                          height: 20,
                          loaded : false
                    }
                }
            }

            state.projects = projects
        },

        setProjectsScrollPosition(state, scrollTop) {

           state.projectsScrollPosition = scrollTop; 

           var pIndex = scrollTop /state.layout.height
           pIndex = Math.floor(Math.abs( pIndex ));

           state.projectsCurrentId = state.projects[pIndex].id;
           state.currentProject = state.projects[pIndex];
           state.projectsCurrentIndex = pIndex;

           // set selected project
        },

        setProjectCurrentIndex : function(state, index) {

            console.log("Project set scroll Index");
        },

        // set store indicators for variable
        setProjectMove : function(state, direction) {

          state.projectMove = Date.now() * direction;   

          if(direction < 0) {
                state.projectMoveLeft = state.projectMove; 
          } else {
              
                state.projectMoveRight = state.projectMove; 
          }
        },


        setPageMove : function(state, direction) {
            
          state.pageMove = Date.now() * direction;   
        },

        setProjectRerender : function(state) {
            
            state.projectRerender = Date.now();
        },

        setProjectsVisible : function(state, visible) {

            state.projectsVisible = visible;
        },

        setFullscreen : function(state, fullscreen) {

            state.layout.fullscreen = fullscreen;
        },

        setCategoryFilter : function(state, category) {

           category = category || false; 
           state.categoryFilter = category;
        },

        setDownloadTermsVisible : function(state,visible) {
           
            state.downloadTermsVisible = visible;
        },

        setDownloadTermsAccepted : function(state, accepted) {
           
            state.downloadTermsAccepted = accepted;
        },

        toggleMobileNavigation  : function(state) {

           state.layout.mobileNavigation =  !state.layout.mobileNavigation;
        },

        hideMobileNavigation  : function(state) {

           state.layout.mobileNavigation =  false;
        },

        showMobileNavigation  : function(state) {

           state.layout.mobileNavigation =  true;
        },

        setLanguage : function(state, language) {
           
            state.language = language;
        },

        setClients : function(state, clients) {

            state.clients = clients;
        }

    },

    /* Actions */
    actions

})

export default store;



// WEBPACK FOOTER //
// ./src/components/store/store.js